import React from 'react'
import { Form, FormProps, Modal, ModalBody,Button, Col, Row  } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import { Case } from '.';
import TextInput from '../../components/TextInput';

export type customCaseFormModalProps = React.PropsWithoutRef<{
    showModal: boolean;
    existingCase?: Case;
    handleClose: () => void;
    handleSubmit: (formData: any) => void;
    formProps?: FormProps;
}>;


const CaseFormModal = ({
    showModal = false,
    existingCase,   
    handleClose,
    handleSubmit,
    formProps,
    
    ...props
  }: customCaseFormModalProps) => {

 const [showParticipantInfoModal, handleShowParticipantInfoModal, handleCloseParticipantInfoModal
 ] =useModal();

 const [showActivityLogModal, handleShowActivityLogModal, handleCloseActivityLogModal
 ] =useModal();
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="xl">
      <ModalBody className="pt-12 ">
        <Row className="border-bottom-dark-gray">
          <Col className={'col-12 col-lg-10 '}>
            <h2 className={'h2 text-sm-20-lg-24 mb-3 pt-2 mb-lg-11'}>
              New Case
            </h2>
          </Col>
        </Row>
        <Row className="m-8">
          <Col className="col-12 col-lg-12 col">
            {' '}
            <span className={'h6'}>Name: Jones Jamie</span>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Plan</Col>
              <Col className="col-8">
                <TextInput placeholder="Define Benefits" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Priority</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Normal" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Initiator</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Participant" />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Category</Col>
              <Col className="col-8">
                <TextInput placeholder=" " />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Record Status</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Standard Process" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Method</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Phone Call #" />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Subject</Col>
              <Col className="col-8">
                <TextInput placeholder=" " />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">QA Status</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to None" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Auth Method</Col>
              <Col className="col-8">
                <TextInput placeholder="Default" />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Detail</Col>
              <Col className="col-8">
                <TextInput placeholder="PIN Reset" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Inbox</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Agents Inbox" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Scope</Col>
              <Col className="col-8">
                <TextInput placeholder="Default to Regular" />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Record Type</Col>
              <Col className="col-8">
                <TextInput placeholder=" " />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="m-8">
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Callback</Col>
              <Col className="col-8">
                <TextInput placeholder="xxx-xxx-xxx" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Callback</Col>
              <Col className="col-8">
                <TextInput placeholder="xxx-xxx-xxx" />
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-lg-4 col">
            <Row className="mt-8">
              <Col className="col-3 p-5">Followup</Col>
              <Col className="col-8">
                <TextInput placeholder="xxx-xxx-xxx" />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="m-8">
          <Col className="col-12 col p-5">
            <div className=" text-input-custom">
            <Form.Group className="mb-3" controlId="comments">
              <Form.Control
                className=""
                as="textarea"
                placeholder="Comments (1000 chars max)"
                rows={4}
              />
              </Form.Group>
            </div>
          </Col>
        </Row>
        <Row className="m-8">
          <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
            <Button
              onMouseDown={handleClose}
              className=" reset-button m-4"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={handleClose}
              className="text-nowrap m-4"
              variant="primary"
            >
              Save For Further Processing
            </Button>
            <Button
              onMouseDown={handleClose}
              className="text-nowrap m-4"
              variant="primary"
            >
              Save & Close
            </Button>
          </section>
        </Row>
      </ModalBody>
    </Modal>
  );
}

export default CaseFormModal